import React from 'react'
import './contact.css'
import {FiMail} from 'react-icons/fi'
import {RiMessengerLine} from 'react-icons/ri'
import {ImWhatsapp} from 'react-icons/im'
import { useRef } from 'react';
import emailjs from 'emailjs-com'


const Contact = () =>
 {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_hftwgu8', 'template_iw9eeob', form.current, 'NctRLIiQgOTTqmx-1')
    
    e.target.reset()
    
  };

  return (
    <section id='contact'> 
        <h5>Get In Touch</h5>
        <h2>Contact Me</h2>

        <div className='container contact__container'>
          <div className='contact__options'>
            <article className='contact__option'>
              <FiMail className='contact__option-icon'/>
              <h4>Email</h4>
              <h5>adydanielgilberth@gmail.com</h5>
              <a href='mailto:adydanielgilberth@gmail.com'>Send a message</a>
            </article>

            <article className='contact__option'>
              <RiMessengerLine className='contact__option-icon'/>
              <h4>Message</h4>
              <h5>Ady Aruan</h5>
              <a href='https://m.me/serenadeboys'>Send a message</a>
            </article>

            <article className='contact__option'>
              <ImWhatsapp className='contact__option-icon'/>
              <h4>Email</h4>
              <h5>+6282168001355</h5>
              <a href='https://api.whatsapp.com/send?phone=6282168001355&text=Hi'>Send a message</a>
            </article>
          </div>
          {/* END OF CNTACT OPTIONS */}
          <form ref={form} onSubmit={sendEmail}>
            <input type="text" name='name' placeholder='Your Name' required />
            <input type="email" name='email' placeholder='Your Email' required />
            <textarea name='message' rows="7" placeholder='Your Message' required></textarea>
            <button type='submit' className='btn btn-primary'> Send Message </button>
          </form>
        </div>
    </section>
  )
}

export default Contact
